import React from 'react';
import { Box } from '@mui/material';
import { WarningAmber as WarningIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

// "⚠ N" pill for flagged activities awaiting admin review; renders nothing when the count is 0 or absent.
export const SuspiciousCountBadge = ({ count }: { count?: number }) => {
  const { t } = useTranslation('contests');
  if (!count) return null;
  return (
    <Box
      component="span"
      title={t('leaderboard.suspiciousCount', { count })}
      sx={{ ml: 0.75, px: 0.75, py: '1px', borderRadius: '999px', fontSize: 11, fontWeight: 600, verticalAlign: 'middle', display: 'inline-flex', alignItems: 'center', gap: '2px', flex: 'none', backgroundColor: 'var(--warn-bg)', color: 'var(--warn)' }}
    >
      <WarningIcon sx={{ fontSize: 13 }} />
      {count}
    </Box>
  );
};
